import type { LocalLibraryHealthStatus } from './LocalLibraryAdapter';

export const UNKNOWN_LOCAL_HEALTH_STATUS: LocalLibraryHealthStatus = {
  status: 'unknown',
  message: null,
  lastRunAt: null,
  mappedLegacyCount: null,
  unresolvedLegacyCount: null,
  rebuilding: false,
  code: null,
  migrationPending: false,
  albumsWithZeroPresentTracks: null,
};
